import React, {memo, useContext, useMemo} from 'react';
import {useIntl} from 'react-intl';
import {ThemeContext} from '../../apiContexts';
import LoadingBar from '../../components/loadingBar';
import ReactTable from '../../components/reactTable';
import {getColumnWidth} from '../../helpers/report';
import {Header, ListStyle} from './styles';

const CertadocFineList = ({data, loading, onSelect}) => {
  const theme = useContext(ThemeContext);
  const intl = useIntl();

  const columns = useMemo(
      () => [
        {
          Header: intl.formatMessage({id: 'sharedName'}),
          accessor: 'deviceName',
          minWidth: 200,
          width: getColumnWidth(data, 'deviceName', intl.formatMessage({id: 'sharedName'})),
        },
        {
          Header: intl.formatMessage({id: 'devicePlate'}),
          accessor: 'plate',
          minWidth: 110,
        },
        {
          Header: intl.formatMessage({id: 'certadocColAit'}),
          accessor: 'ait',
          minWidth: 150,
        },
        {
          Header: intl.formatMessage({id: 'certadocColDate'}),
          accessor: 'dataMulta',
          minWidth: 110,
        },
        {
          Header: intl.formatMessage({id: 'certadocColTime'}),
          accessor: 'horaMulta',
          minWidth: 100,
        },
        {
          Header: intl.formatMessage({id: 'certadocColDescription'}),
          accessor: 'descricao',
          minWidth: 320,
          width: getColumnWidth(data, 'descricao', intl.formatMessage({id: 'certadocColDescription'})),
        },
        {
          Header: intl.formatMessage({id: 'certadocColValue'}),
          accessor: 'valorMulta',
          minWidth: 120,
          Cell: ({cell: {value}}) =>
            value == null ? '' : Number(value).toLocaleString('pt-BR', {minimumFractionDigits: 2}),
        },
        {
          Header: intl.formatMessage({id: 'certadocColSituation'}),
          accessor: 'situacao',
          minWidth: 200,
        },
        {
          Header: intl.formatMessage({id: 'certadocColStatus'}),
          accessor: 'flagStatus',
          minWidth: 160,
        },
        {
          Header: intl.formatMessage({id: 'certadocColAgency'}),
          accessor: 'tabelaOrigem',
          minWidth: 180,
        },
        {
          Header: intl.formatMessage({id: 'certadocColCode'}),
          accessor: 'codigoInfracao',
          minWidth: 130,
        },
        {
          Header: intl.formatMessage({id: 'certadocColDueDate'}),
          accessor: 'dataValidade',
          minWidth: 120,
        },
        {
          Header: intl.formatMessage({id: 'certadocColAddress'}),
          accessor: 'endereco',
          minWidth: 260,
          width: getColumnWidth(data, 'endereco', intl.formatMessage({id: 'certadocColAddress'})),
        },
        {
          Header: intl.formatMessage({id: 'certadocColCity'}),
          accessor: 'municipio',
          minWidth: 180,
        },
        {
          Header: intl.formatMessage({id: 'certadocColState'}),
          accessor: 'uf',
          minWidth: 70,
        },
        {
          Header: intl.formatMessage({id: 'certadocColDocuments'}),
          id: 'documents',
          minWidth: 160,
          accessor: (row) => row.boleto || row.respaldoOrgao || '',
          Cell: ({row: {original}}) => (
            <>
              {original.boleto && (
                <a href={original.boleto} target="_blank" rel="noopener noreferrer">
                  {intl.formatMessage({id: 'certadocDocumentTicket'})}
                </a>
              )}
              {original.boleto && original.respaldoOrgao && ' · '}
              {original.respaldoOrgao && (
                <a href={original.respaldoOrgao} target="_blank" rel="noopener noreferrer">
                  {intl.formatMessage({id: 'certadocDocumentSupport'})}
                </a>
              )}
            </>
          ),
        },
      ],
      [data],
  );

  const selectItem = (props) => onSelect && onSelect(props);

  return (
    <ListStyle theme={theme} className="custom-shadow-2">
      <Header>
        <h5>{intl.formatMessage({id: 'reportCertadocFines'})}</h5>
      </Header>
      {loading ? (
        <LoadingBar />
      ) : (
        <ReactTable
          data={data}
          columns={columns}
          selectItem={selectItem}
          listHeight={300}
        />
      )}
    </ListStyle>
  );
};

export default memo(CertadocFineList);
